<template>
  <div class="add-content">
    <div class="top-title">
      <div />
      <div>故事基本信息</div>
    </div>
    <div class="form-dis">
      <div class="item-width form-left">
        <div class="form-item ">
          <div class="item-name name-left">故事名称</div>
          <el-input v-model="story.name" placeholder="请输入故事名称" />
        </div>
        <div class="form-item">
          <div class="item-name name-left">故事分类</div>
          <el-select v-model="story.storyType" filterable placeholder="请选择故事分类" value-key="code" @change="changeType">
            <el-option v-for="(type) in typeList" :key="type.code" :label="type.value" :value="type" />
          </el-select>
        </div>
      </div>
      <div class="des item-width">
        <div class="item-name">故事描述</div>
        <el-input v-model="story.description" rows="3" type="textarea" placeholder="请输入故事描述" />
      </div>
    </div>
    <div class="top-title middle-top">
      <div />
      <div>故事内容</div>
    </div>
    <div class="scene-list">
      <div class="add-scene">
        <el-button @click="addTab(editableTabsValue)">
          +添加故事场景
        </el-button>
      </div>
      <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab">
        <el-tab-pane
          v-for="(sceneItem, index) in sceneList"
          :key="sceneItem.name"
          :label="sceneItem.title"
          :name="sceneItem.name"
        >
          <div style="height: 100%;display: flex;flex-direction: column;overflow: auto;">
            <div class="scene-item">
              <div class="item-name name-left">场景名称</div>
              <el-input v-model="sceneList[index].sceneName" placeholder="请输入场景名称" />
            </div>
            <div class="scene-des">
              <div class="item-name">场景描述</div>
              <el-input v-model="sceneList[index].description" rows="3" type="textarea" placeholder="请输入场景描述" />
            </div>
            <div class="task-title">
              <div>步骤合集</div>
              <div>
                <span @click="showModeDialog">+添加模版步骤</span>
                <span @click="showCustomDialog">+添加自定义步骤</span>
              </div>
            </div>
            <div style="flex: 1;display: flex;flex-direction: column;">
              <div class="select-list">
                <div
                  v-for="(item, task_index) in sceneItem.taskElements"
                  :key="task_index"
                  class="list-item"
                  :style="{ background: selectTaskIndex === task_index ? '#ecf5ff' : '' }"
                >
                  <span @click="editTask(item, task_index)">{{ item.name }}</span>
                  <i class="el-icon-close close-icon" @click="delTask(index, task_index,item)" />
                </div>
              </div>
              <div v-if="showTaskContent" class="tast-detail task-margin">
                <el-form ref="ruleForm" :model="taskContent" label-width="100px">
                  <el-form-item label="问题" prop="question">
                    <el-input v-model="taskContent.questions[0]" type="textarea" />
                  </el-form-item>
                  <el-form-item label="答案" prop="answer">
                    <el-input v-model="taskContent.answer" type="textarea" />
                  </el-form-item>
                  <el-form-item label="问题意图" prop="questionIntent">
                    <el-input v-model="taskContent.questionIntent" type="textarea" />
                  </el-form-item>
                  <el-form-item label="答案意图" prop="answerIntent">
                    <el-input v-model="taskContent.answerIntent" type="textarea" />
                  </el-form-item>
                </el-form>
                <!-- <div class="question-content">
                  <div class="content-item text">
                    <div>问题： {{ taskContent.name }}</div>
                    <div>答案： {{ taskContent.answer }}</div>
                  </div>
                  <div class="content-item">
                    <div>问题意图： {{ taskContent.questionIntent }}</div>
                    <div>答案意图： {{ taskContent.answerIntent }}</div>
                  </div>
                </div> -->
                <div class="check-list check-detail">
                  <div>
                    检查点：
                  </div>
                  <div v-for="(item, index) in taskContent.checkList" :key="index">
                    <el-input v-model="taskContent.checkList[index]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="sava-btn">
      <el-button type="primary" @click="saveData">保存</el-button>
    </div>
    <el-dialog
      :visible.sync="modeTableVisible"
      width="70%"
      top="10vh"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="mode-dialog">
        <div class="form-item">
          <div class="item-name">选择模版</div>
          <el-select
            v-model="currentTaskBase"
            :disabled="isSelectTask"
            style="margin-left: -6px;"
            placeholder="请选择任务模版"
            value-key="id"
            @change="changeTaskBase"
          >
            <el-option v-for="task in taskBaseList" :key="task.id" :label="task.name" :value="task" />
          </el-select>
        </div>
        <div class="form-item task-select">
          <div class="item-name">全选</div>
          <el-switch v-model="allTask" active-color="#419eee" @change="selectTask" />
        </div>
        <div class="dialog-content">
          <div class="mode-content">
            <el-collapse>
              <el-collapse-item v-for="(currentTask, index) in taskList" :key="currentTask.id">
                <template slot="title">
                  <el-checkbox v-model="currentTask.checked" @change="selectQuestion(index)">{{ currentTask.name
                  }}</el-checkbox>
                </template>
                <div class="tast-detail">
                  <div class="question-content">
                    <div class="content-item text">
                      <div>问题： {{ currentTask.questions[0] }}</div>
                      <div>答案： {{ currentTask.answer }}</div>
                    </div>
                    <div class="content-item">
                      <div>问题意图： {{ currentTask.questionIntent }}</div>
                      <div>答案意图： {{ currentTask.answerIntent }}</div>
                    </div>
                  </div>
                  <div class="check-list">
                    <div>
                      检查点：
                    </div>
                    <div v-for="(item, index) in currentTask.checkList" :key="index">
                      <span>{{ item }}</span>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="mode-btn">
          <el-button class="sub-btn" @click="closeMode()">取消</el-button>
          <el-button class="sub-btn" type="primary" @click="saveTask()">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="customTableVisible" width="75%" :show-close="false" :close-on-click-modal="false">
      <div class="custom-dialog">
        <el-form ref="ruleForm" :model="taskForm" :rules="rules" label-width="100px">
          <el-form-item label="问题" prop="question">
            <el-input v-model="taskForm.question" type="textarea" />
          </el-form-item>
          <el-form-item label="答案" prop="answer">
            <el-input v-model="taskForm.answer" type="textarea" />
          </el-form-item>
          <el-form-item label="问题意图" prop="questionIntent">
            <el-input v-model="taskForm.questionIntent" type="textarea" />
          </el-form-item>
          <el-form-item label="答案意图" prop="answerIntent">
            <el-input v-model="taskForm.answerIntent" type="textarea" />
          </el-form-item>
        </el-form>
        <div class="task-check">
          <div class="check-name">检查点</div>
          <div class="custom-check">
            <div v-for="(check, c_i) in taskForm.checkList" :key="c_i" class="check">
              <el-input v-model="taskForm.checkList[c_i]" type="textarea" :rows="2" />
              <i class="el-icon-circle-plus-outline" @click="addCheck" />
              <i
                v-if="taskForm.checkList.length > 1"
                class="el-icon-remove-outline"
                @click="taskForm.checkList.splice(c_i, 1)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="custom-btn">
        <el-button @click="closeCustom()">取消</el-button>
        <el-button type="primary" @click="saveCustom()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { storySave, getTaskList, getTaskDetail, getStoryType, storyDetail, updateStory } from '@/api/exercise'
export default {
  data() {
    return {
      story: {
        name: '',
        description: '',
        storyType: {}
      },
      selectTaskIndex: -1,
      modeTableVisible: false,
      customTableVisible: false,
      taskBaseList: [],
      typeList: [],
      resourceTypeList: [],
      taskContent: {},
      showTaskContent: false,
      editableTabsValue: '1',
      sceneList: [{
        title: '场景1',
        name: '1',
        sceneName: '',
        description: '',
        taskElements: []
      }],
      tabIndex: 1,
      isSelectTask: false,
      allTask: false,
      currentTaskBase: null,
      taskList: [],
      taskForm: {
        question: '',
        answer: '',
        questionIntent: '',
        answerIntent: '',
        checkList: ['']
      },
      rules: {
        question: [
          { required: true, message: '请输入问题', trigger: 'blur' }
        ],
        answer: [
          { required: true, message: '请输入回答', trigger: 'blur' }
        ],
        answerIntent: [
          { required: true, message: '请输入问题意图', trigger: 'blur' }
        ],
        questionIntent: [
          { required: true, message: '请输入答案意图', trigger: 'blur' }
        ]
      },
      sceneTaskElements: [],
      currentTaskType: '',
      fileIdList: [],
      baseIdList: []
    }
  },
  created() {
    this.queryTaskList()
    this.getType()
    if (this.$route.params.story) {
      this.queryStory()
    }
  },
  methods: {
    queryStory() {
      this.sceneList = []
      storyDetail({ id: this.$route.params.story._id }).then(res => {
        this.story = res.data
        const sceneList = res.data.scenes
        sceneList.forEach((el, index) => {
          const elementList = []
          el.tasks.forEach(item => {
            const elementObject = {
              answer: item.qaPairs[0].answer,
              questions: item.qaPairs[0].questions,
              answerIntent: item.qaPairs[0].answerIntent,
              questionIntent: item.qaPairs[0].questionIntent,
              checkList: item.checkList,
              name: item.task,
              fileId: item.fileId,
              baseId: item.baseId
            }
            this.fileIdList.push({ sceneName: '场景' + (index + 1), storyFileId: item.fileId })
            this.baseIdList.push({ sceneName: '场景' + (index + 1), id: item.baseId })
            elementList.push(elementObject)
          })
          const sceneObject = {
            title: '场景' + (index + 1),
            name: (index + 1).toString(),
            sceneName: el.scene,
            description: el.description,
            taskElements: elementList
          }
          this.sceneList.push(sceneObject)
          this.tabIndex = this.sceneList.length
        })
        console.log('this.sceneList---------', this.sceneList)
        this.typeList.forEach(el => {
          if (el.code === res.data.storyType) {
            this.story.storyType = el
          }
        })
      })
    },
    queryTaskList() {
      getTaskList({}).then(res => {
        this.taskBaseList = res.data
      })
    },
    getType() {
      getStoryType().then(res => {
        this.typeList = res.data
      })
    },
    selectTask() {
      if (this.allTask) {
        this.taskList.forEach(el => {
          el.checked = true
          this.$set(el, 'checked', true)
          this.sceneTaskElements.push(el)
        })
      } else {
        this.taskList.forEach(el => {
          this.$set(el, 'checked', false)
          this.sceneTaskElements = []
        })
      }
    },
    delTask(scene_index, task_index, item) {
      this.$confirm('此操作将删除选中的任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.fileIdList.findIndex(i => i.storyFileId === item.storyFileId)
        this.fileIdList.splice(index, 1)
        const id_index = this.baseIdList.findIndex(i => i.id === item.id)
        this.baseIdList.splice(id_index, 1)
        this.sceneList[scene_index].taskElements.splice(task_index, 1)
        this.taskContent = {}
        this.showTaskContent = false
        this.selectTaskIndex = -1

        console.log(333, this.fileIdList, this.baseIdList)
      })
    },
    showModeDialog() {
      this.currentTaskBase = null
      this.taskList = []
      this.allTask = false
      this.sceneTaskElements = []
      this.modeTableVisible = true
    },
    closeMode() {
      this.currentTaskBase = null
      this.taskList = []
      this.allTask = false
      this.sceneTaskElements = []
      this.modeTableVisible = false
    },
    saveTask() {
      this.taskList.forEach(el => {
        if (el.checked) {
          this.fileIdList.push({ sceneName: this.editableTabsValue, storyFileId: this.currentTaskBase.storyFileId })
          this.baseIdList.push({ sceneName: this.editableTabsValue, id: this.currentTaskBase.id })
        }
      })
      this.modeTableVisible = false
      this.sceneList[this.editableTabsValue - 1].taskElements = [...this.sceneList[this.editableTabsValue - 1].taskElements, ...this.sceneTaskElements]
      if (this.resourceTypeList.indexOf(this.currentTaskType) === -1) {
        this.resourceTypeList.push(this.currentTaskType)
      }

      console.log(222, this.fileIdList, this.baseIdList)
    },
    selectQuestion(index) {
      this.sceneTaskElements = []
      this.taskList.forEach(el => {
        if (el.checked) {
          el.baseId = this.currentTaskBase.storyFileId
          el.fileId = this.currentTaskBase.id
          this.sceneTaskElements.push(el)
        }
      })
    },
    editTask(task, index) {
      this.taskContent = task
      this.selectTaskIndex = index
      this.showTaskContent = true
    },
    changeType(type) {
      this.story.storyType = type
    },
    changeTaskBase(file) {
      this.allTask = false
      this.currentTaskType = file.type
      getTaskDetail(file.id).then(res => {
        this.taskList = res.data.taskElements
        if (this.taskList) {
          this.taskList.forEach((el, index) => {
            el.name = el.questions[0]
            this.$set(el, 'checked', false)
          })
        }
      })
    },
    closeCustom() {
      this.customTableVisible = false
      this.taskForm.question = ''
      this.taskForm.answer = ''
      this.taskForm.questionIntent = ''
      this.taskForm.answerIntent = ''
      this.taskForm.checkList = ['']
      this.taskForm.questions = []
      this.taskForm.name = ''
    },
    showCustomDialog() {
      this.taskForm.question = ''
      this.taskForm.answer = ''
      this.taskForm.questionIntent = ''
      this.taskForm.answerIntent = ''
      this.taskForm.checkList = ['']
      this.customTableVisible = true
    },
    saveCustom() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid && this.taskForm.checkList[0] !== '') {
          const taskFormCopy = JSON.parse(JSON.stringify(this.taskForm))
          this.$set(taskFormCopy, 'name', taskFormCopy.question)
          this.$set(taskFormCopy, 'questions', [taskFormCopy.question])
          this.sceneList[this.editableTabsValue - 1].taskElements.push(taskFormCopy)
          this.customTableVisible = false
        } else {
          this.$message({
            message: `请先完善检查点`,
            type: 'error',
            duration: 5 * 1000
          })
        }
      })
    },
    addCheck() {
      const cl = this.taskForm.checkList.filter(item => !item)
      if (cl && cl.length) {
        this.$message({
          message: `请先完善上一个检查点`,
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        this.taskForm.checkList.push('')
      }
    },
    addTab(targetName) {
      const nameFilter = this.sceneList.filter(item => item.sceneName === '')
      const taskFilter = this.sceneList.filter(item => !item.taskElements.length)
      if (!nameFilter.length && !taskFilter.length) {
        this.showTaskContent = false
        this.taskContent = {}
        const newTabName = ++this.tabIndex + ''
        this.sceneList.push({
          title: '场景' + newTabName,
          name: newTabName,
          sceneName: '',
          taskElements: []
        })
        this.editableTabsValue = newTabName
      } else if (nameFilter.length) {
        this.$message({
          message: `请先完善上一个场景名称`,
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        this.$message({
          message: `请先选择上一个场景任务`,
          type: 'error',
          duration: 5 * 1000
        })
      }
    },
    clickTab() {
      this.showTaskContent = false
      this.taskContent = {}
      this.selectTaskIndex = -1
    },
    removeTab(targetName) {
      console.log('removeTab', targetName)
      this.showTaskContent = false
      this.taskContent = {}
      let activeName = this.editableTabsValue
      this.fileIdList.splice(this.fileIdList.findIndex(file => file.sceneName === activeName), 1)
      this.baseIdList.splice(this.baseIdList.findIndex(file => file.sceneName === activeName), 1)
      if (activeName === targetName) {
        this.sceneList.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = this.sceneList[index + 1] || this.sceneList[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      console.log('del---scene-----', this.fileIdList, this.baseIdList)
      this.editableTabsValue = activeName
      const scene = this.sceneList.splice(this.sceneList.findIndex(tab => tab.name === targetName), 1)
      console.log('del---scene', scene)
      console.log('del---scene-----', this.fileIdList, this.baseIdList)
      // this.sceneList = this.sceneList.filter(tab => tab.name !== targetName)
    },
    saveData() {
      if (this.story.name !== '' && this.story.storyType.code !== '') {
        const nameFilter = this.sceneList.filter(item => item.sceneName === '')
        const taskFilter = this.sceneList.filter(item => !item.taskElements.length)
        if (!nameFilter.length && !taskFilter.length) {
          if (this.$route.params.story) {
            const params = JSON.parse(JSON.stringify(this.story))
            params.storyType = params.storyType.code
            const sceneList = []
            this.sceneList.forEach(scene => {
              const elementList = []
              scene.taskElements.forEach(task => {
                const taskObject = {
                  task: task.name,
                  qaPairs: [{
                    answer: task.answer,
                    answerIntent: task.answerIntent,
                    questionIntent: task.questionIntent,
                    questions: task.questions
                  }],
                  checkList: task.checkList,
                  description: task.description
                }
                elementList.push(taskObject)
              })
              const sceneObject = {
                scene: scene.sceneName,
                description: scene.description,
                tasks: elementList
              }
              sceneList.push(sceneObject)
            })
            params.scenes = sceneList
            params.fileIdList = this.fileIdList.map(file => file.storyFileId)
            params.baseIdList = this.baseIdList.map(base => base.id)
            updateStory(params).then(res => {
              this.$message({
                message: `更新成功`,
                type: 'success',
                duration: 5 * 1000
              })
              this.$router.push({ name: 'storyList' })
            })
          } else {
            const sceneList = []
            this.sceneList.forEach(el => {
              const object = {
                sceneName: el.sceneName,
                sceneDescription: el.description,
                taskElements: el.taskElements
              }
              sceneList.push(object)
            })
            const fileIdList = this.fileIdList.map(file => file.storyFileId)
            const baseIdList = this.baseIdList.map(base => base.id)
            const params = {
              storyName: this.story.name,
              storyDescription: this.story.description,
              storyType: this.story.storyType.code,
              resourceTypeList: this.resourceTypeList,
              sceneList: sceneList,
              fileIdList: fileIdList,
              baseIdList: baseIdList
            }
            console.log('params---', params)
            storySave(params).then(res => {
              this.$message({
                message: `保存成功`,
                type: 'success',
                duration: 5 * 1000
              })
              this.$router.push({ name: 'storyList' })
            })
          }
        } else {
          this.$message({
            message: `请完善场景信息`,
            type: 'error',
            duration: 5 * 1000
          })
        }
      } else if (!this.story.storyType.code) {
        this.$message({
          message: `请选择故事类型`,
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        this.$message({
          message: `请填写故事名称`,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .el-textarea__inner{
    resize: none;
  }
}
.add-content {
  width: 100%;
  height: 100%;
  background-color: #F2F2F2;
  padding: 20px 50px 20px 20px;
  display: flex;
  flex-direction: column;
}

.sava-btn {
  text-align: end;
  padding: 10px 30px;
}

.top-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;

  div:nth-child(1) {
    width: 5px;
    height: 20px;
    background-color: #0000FF;
    margin-right: 10px;
  }
}

.middle-top {
  margin: 30px 0;
}

.scene-list {
  background-color: #fff;
  padding: 20px;
  position: relative;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  ::v-deep{
    .el-tabs{
      height: 100%;
      overflow: auto;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .el-tabs__content{
      flex: 1;
    }
    .el-tab-pane{
      height: 100%;
    }
  }

  .add-scene {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;

    .el-button {
      padding: 10px;
    }
  }

  :deep(.el-tabs__nav-scroll) {
    width: 80%;
  }
}

.form-dis {
  margin-top: 30px;
  width: 100%;
  height: 150px;
  background-color: #fff;
  display: flex;
  align-items: start;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
}

.form-item {
  display: flex;
  align-items: center;
  width: 100%;
}

.task-select {
  height: 30px;
  display: flex;
  align-items: center;
}

.scene-des {
  display: flex;
  align-items: center;
  margin-top: 20px;

  :deep(.el-textarea__inner) {
    height: 45px;
  }

}

.scene-item {
  display: flex;
  align-items: center;
  width: 45%;
}

.task-title {
  justify-content: space-between;
  font-size: 14px;
  height: 30px;
  margin: 20px 0;
  display: flex;
  align-items: center;

  span {
    border: 1px solid #000000;
    margin-left: 20px;
    padding: 5px;
    border-radius: 10px;
    opacity: 0.8;
    cursor: pointer;
  }
}

.item-width {
  width: 48%;

}

.form-left {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .el-select {
    width: 100%;
  }

}

.des {
  display: flex;

  :deep(.el-textarea__inner) {
    height: 110px;
  }

  div:nth-child(1) {
    padding: 12px 0 0 8px;
  }
}

.item-name {
  width: 75px;
  flex-shrink: 0;
  font-size: 14px;
}

.name-left {
  &::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}

:deep(.el-dialog) {
  background-color: #F2F2F2;
  height: 80vh;

}

.mode-dialog {
  width: 100%;
  height: 75vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: -5vh;

  .el-select {
    width: 50%;
  }

  .dialog-content {
    width: 100%;
    height: 52vh;
    padding: 15px;
    background-color: #fff;
    border-radius: 10px;
  }

  .mode-content {
    width: 100%;
    height: 100%;
    overflow: auto;

    :deep(.el-checkbox, .el-checkbox__input) {
      white-space: wrap;
      display: flex;
      align-items: center;
    }

    :deep(.el-collapse-item__header) {
      padding: 10px;
      height: auto;
    }
  }

  .mode-btn {
    width: 100%;
    height: 5vh;
    display: flex;
    justify-content: end;

    .el-button {
      height: 4vh;
      display: flex;
      align-items: center;
    }
  }
}
.task-margin {
  padding: 10px
}
.tast-detail {
  border: 1px solid #939393;
  color: #409EFF;
  margin: 0 10px;
}

.question-content {
  display: flex;
}

.content-item {
  width: 50%;
  padding: 10px;
  border-bottom: 1px solid #939393;

}

.text {
  border-right: 1px solid #939393;
}
.check-detail {
  display: flex;
  div {
    margin-right: 10px;
    color: #000000;
  }
}
.check-list {
  padding: 10px;
}

.custom-dialog {
  width: 100%;
  height: 60vh;
  overflow: auto;

  .task-check {
    width: 100%;
    display: flex;

    .check-name {
      color: #606266;
      font-weight: 600;
      width: 100px;
      text-align: end;
      padding-right: 10px;
      line-height: 40px;

      &::before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
      }
    }

    .el-icon-circle-plus-outline {
      font-size: 20px;
      color: green;
      margin: 0 10px;
    }

    .el-icon-remove-outline {
      font-size: 20px;
      color: red;
    }

    .custom-check {
      width: 80%;

      div {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
    }
  }
}

.custom-btn {
  width: 100%;
  height: 5vh;
  display: flex;
  justify-content: end;
  align-items: center;
}

.select-list {
  border: 1px solid #DCDFE6;
  border-radius: 5px;
  min-height: 40px;
  font-size: 14px;
  color: #606266;
  padding: 5px;
  flex: 1;

  .list-item {
    display: inline-flex;
    align-items: center;
    border: 1px solid #EBEEF5;
    border-radius: 5px;
    height: fit-content;
    margin: 5px;

    span {
      margin: 10px;
      cursor: pointer;
    }

    .close-icon {
      margin-right: 10px;
    }
  }
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
</style>
